import 'babel-polyfill'
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import router from '../router'
import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex)

/* eslint-disable */
const state = {
  auth: {
    authorized: false,
    userRole: '',
    user: null
  },
  alert: {
    isAlert: false,
    isHead: true,
    alertMsg: '尚未登入',
    type: 'alert'
  },
  isAddCart: false,
  isAddWish: false,
  isLoading: false,

  // 置頂通知
  isIndexTopNotice: true,
  isIndexTopMainBody: false,

  // 首頁banner
  isIndexAlert: true,

  routeRecord: 'index',
  errorMessage: '',
  cart: {
    list: [],
    totalPrice: 0,
    num: 0
  },
  cartNum: 0,
  order: {
    orderNum: null
  },
  apiUrl: process.env.NODE_ENV === 'production' ? 'https://api.liveabc.com' : 'https://apitest.liveabc.com',
  nodeEnv: process.env.NODE_ENV
}

const getters = {
  user: state => state.auth.user,
  account: state => state.auth.user.name,
  authorized: state => state.auth.authorized,
  userRole: state => state.auth.userRole,
  isLoading: state => state.isLoading,
  isAlert: state => state.alert.isAlert,
  isIndexAlert: state => state.isIndexAlert,
  alertMsg: state => state.alert.alertMsg,
  cartNum: state => state.cart.num,
  cartList: state => state.cart.list,
  totalPrice: state => state.cart.totalPrice,
  errorMessage: state => state.errorMessage,
  order: state => state.order,
  routeRecord: state => state.routeRecord,
  nodeEnv: state => state.nodeEnv,
  isIndexTopNotice: state => state.isIndexTopNotice,
  isIndexTopMainBody: state => state.isIndexTopMainBody
}

const actions = {
  isIndexTopNotice: (context, data) => {
    context.commit('ISINDEXTOPNOTICE', data)
  },
  isIndexTopMainBody: (context, data) => {
    context.commit('ISINDEXTOPBODY', data)
  },
  updateIndexAlert (context, data) {
    context.commit('INDEXALERT', data)
  },

  isLoading: (context, data) => {
    context.commit('ISLOADING', data)
  },
  isAddingCart: (context, data) => {
    context.commit('ISADDCART', data)
  },
  isAddingWish: (context, data) => {
    context.commit('ISADDWISH', data)
  },
  updateAlert (context, data) {
    context.commit('ALERTING', data)
  },

  refreshToken: async () => {
    let { data } = await axios.get('/user/token/refresh')
    localStorage.setItem('authToken', data.access_token)
    window.location.reload()
  },

  register: async ({ dispatch }, user) => {
    await axios.post('/register?proof=1', {
      'name': user.name,
      'password': user.password,
      'account': user.account,
      'country_code': user.country_code,
      'mobile': user.mobile,
      'code': user.code,
      'isAgreeReceiveDM': user.isAgreeReceiveDM
    })
    .then(() => {
      dispatch('login', { account: user.account, password: user.password })
      router.push({ name: 'jump' })
    })
    .catch(() => {
      // dispatch('updateAlert', { isAlert: true, isHead: true, alertMsg: '驗證碼錯誤或帳號已存在', type: 'alert' })
    })
  },

  login: async ({ commit, dispatch }, user) => {
    await axios.post('/login', {
      'email': user.account,
      'password': user.password
    })
    .then(response => {
      commit('LOGIN', response.data)
      localStorage.setItem('authToken', response.data.access_token)
      dispatch('getProfile')
    })
    .catch(error => {
      if (error.response.status === 401) {
        // dispatch('updateAlert', { isAlert: true, isHead: true, alertMsg: '帳號密碼錯誤', type: 'alert' })
      }
    })
  },
  async loginByGoogle({ commit, dispatch }, token) {
    try {
      const path = '/google_login'
      const response = await axios.post(path, {
        token: token
      })

      commit('LOGIN')
      localStorage.setItem('authToken', response.data.access_token)

      if (response) {
        dispatch('getProfile')
        // router.push({ name: 'index' })

        router.push({ name: state.routeRecord })
        dispatch('updateLocalCart')
      }
    } catch (err) {
      console.error(err.response)
      router.push({ name: 'register', query: err.response.data.data })
    }
  },

  loginFB: async ({ commit, dispatch }, accessVal) => {
    try {
      const response = await axios.post('/facebook_login', {
        access_token: accessVal
      })
      commit('LOGIN', response.data)
      localStorage.setItem('authToken', response.data.access_token)
      dispatch('getProfile')
    } catch (error) {
      console.error(error)
      dispatch('updateAlert', {
        isAlert: true,
        isHead: true,
        alertMsg: 'E-mail帳號未建立',
        type: 'alert'
      })
    }
  },

  useTokenLogin: async({ commit, dispatch }, token) => {
    localStorage.setItem('authToken', token)
    await dispatch('getProfile')

    let loginToken = { access_token: token, expires_in: 28800, token_type: 'bearer' }
    commit('LOGIN', loginToken)
  },

  getProfile: async ({ commit, dispatch }) => {
    let { data } = await axios.get('/user/me')
    if (data && data.error) {
      dispatch('logout')
    } else {
      commit('UPDATEPROFILE', data)
    }
  },

  logout: async ({ commit, dispatch }) => {
    if (localStorage.getItem('authToken')) {
      if (window.google && google.accounts && google.accounts.id) {
        google.accounts.id.disableAutoSelect()
      }
      await axios.post('/logout')
        .then(() => {
          commit('LOGOUT')
          localStorage.removeItem('products')
          dispatch('updateCart')
        }).catch(() => {
          commit('LOGOUT')
        });
    } else {
      commit('LOGOUT')
    }
  },

  // 更新購物車項目
  updateCart: async ({ commit, getters }) => {
    let productsNum = 0
    let cartTotal = 0
    let items = []

    if (getters.authorized) {
      try {
        const response = await axios.get('/cart/info')
        items = Array.isArray(response.data) ? response.data : []
      } catch (error) {
        console.error('獲取雲端購物車失敗:', error)
        items = []
      }
    } else {
      const localItems = JSON.parse(localStorage.getItem('products'))
      items = Array.isArray(localItems) ? localItems : []
    }

    for (const item of items) {
      productsNum += item.quantity || 0
      cartTotal += item.fixed_price || 0
    }

    // commit('UPDATECART', [productsNum, items, cartTotal])
    commit('UPDATECART', { productsNum: productsNum, items: items, cartTotal: cartTotal })
  },

  // 更新本地端購物車到雲端
  updateLocalCart: async ({ dispatch }) => {
    try {
      const stored = localStorage.getItem('products')
      const localItems = stored ? JSON.parse(stored) : []

      if (!Array.isArray(localItems)) return

      // 取得雲端購物車資料
      const serverRes = await axios.get('/cart/info')
      const serverItems = Array.isArray(serverRes.data) ? serverRes.data : []

      // 建立 item 的唯一識別鍵 (例如 id + selected_gifts)，避免重複
      const itemKey = item => `${item.id}-${JSON.stringify(item.selected_gifts || '')}`

      const mergedMap = new Map()
      for (const item of serverItems) {
        mergedMap.set(itemKey(item), item)
      }
      for (const item of localItems) {
        const key = itemKey(item)
        if (mergedMap.has(key)) {
          // 合併數量
          mergedMap.get(key).quantity += item.quantity || 1
        } else {
          mergedMap.set(key, { ...item, quantity: item.quantity || 1 })
        }
      }

      const mergedItems = Array.from(mergedMap.values())

      if (mergedItems.length > 0) {
        const postRes = await axios.post('/cart/info', mergedItems)

        if (postRes?.status === 200) {
          localStorage.removeItem('products')
          dispatch('updateCart')
        } else {
          console.warn('雲端更新失敗:', postRes)
        }
      }
    } catch (error) {
      console.error('更新購物車失敗:', error)
    }
  },

  postCart: async ({ dispatch, getters, commit }, data) => {
    console.log(data)
    if (!getters.authorized || !data) return

    let productsNum = 0
    let cartTotal = 0

    const jsonData = data ? data : []

    try {
      for (const item of data) {
        productsNum += item.quantity || 0
        cartTotal += item.fixed_price || 0
      }
      commit('UPDATECART', { productsNum: productsNum, items: data, cartTotal: cartTotal })

      const response = await axios.post('/cart/info', jsonData)
      if (response) {
        dispatch('updateCart')
      }
    } catch (error) {
      console.error('更新購物車資料失敗:', error)
    }
  },

  async updateQuantity ({ commit, getters, dispatch }, { id, quantity }) {
    if (getters.authorized) {
      commit('UPDATE_ITEM_QUANTITY', { id, quantity })

      const cleanItems = getters.cartList.map(p => ({
        id: p.id,
        quantity: p.quantity
      }))

      await dispatch('postCart', cleanItems)
    } else {
      const products = JSON.parse(localStorage.getItem('products')) || []
      const product = products.find((p) => p.id === id)
      if (product) {
        product.quantity = quantity
        localStorage.setItem('products', JSON.stringify(products))
      }
    }
  },

  // 紀錄route
  routeRecord: (context, data) => {
    context.commit('ROUTERECORD', data)
  }
}

const mutations = {
  ISINDEXTOPNOTICE (state, data) {
    state.isIndexTopNotice = data
  },
  ISINDEXTOPBODY (state, data) {
    state.isIndexTopMainBody = data
  },
  INDEXALERT (state, data) {
    state.isIndexAlert = data
  },
  ISLOADING (state, data) {
    state.isLoading = data
  },
  ROUTERECORD (state, data) {
    state.routeRecord = data.routeName
  },
  ISADDCART (state, data) {
    state.isAddCart = data
  },
  ISADDWISH (state, data) {
    state.isAddWish = data
  },
  ALERTING (state, data) {
    state.alert.isAlert = data.isAlert
    state.alert.isHead = data.isHead
    state.alert.alertMsg = data.alertMsg
    state.alert.type = data.type
  },
  LOGIN (state) {
    state.auth.authorized = true
    // state.auth.user = data
  },

  UPDATEPROFILE (state, data) {
    state.auth.userRole = data.role
    state.auth.user = { ...data }
  },

  // fb login
  LOGINFB (state, data) {
    state.auth.authorized = true
    state.auth.user = data.authResponse
  },

  UPDATEPROFILEFB (state, data) {
    state.auth.userRole = 'FBuser'
    state.auth.user = {
      'id': data.id,
      'email': data.email,
      'name': data.name
    }
  },

  LOGOUT (state) {
    state.auth.authorized = false
    state.auth.user = {}
    state.auth.userRole = ''
    localStorage.removeItem('authToken')
  },

  setErrorMessage (state, message) {
    state.errorMessage = message
  },

  UPDATECART (state, data) {
    state.cart.num = data.productsNum
    state.cart.list = data.items
    state.cart.totalPrice = data.cartTotal
  },
  UPDATE_ITEM_QUANTITY (state, { id, quantity }) {
    if (!Array.isArray(state.cart.list)) return

    const product = state.cart.list.find(p => p.id === id)
    if (product) {
      product.quantity = quantity
    }
  }
}

const debug = process.env.NODE_ENV !== 'production'
export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
  modules: {
  },
  strict: debug,
  plugins: [createPersistedState({
    paths: [
      'auth'
    ]
  })]
})
